import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import httpClient from "../../lib/httpClient";

export const Settings = () => {
  const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
  const REACT_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
  const REACT_APP_HAZARD_BASE_API_URL = process.env.REACT_APP_HAZARD_BASE_API_URL;

  const [dopplerData, setDopplerData] = useState(null);
  const [expiraionDate, setExpiraionDate] = useState(null);

  const dotStyle = {
    height: "12px",
    width: "12px",
    backgroundColor: "green",
    borderRadius: "50%",
    display: "inline-block",
    marginRight: "5px",
  };

  useEffect(() => {
    httpClient()
      .get("/proxy/doppler")
      .then(({ data }) => {
        setDopplerData(data);
      });
  }, []);

  useEffect(() => {
    httpClient()
      .get("/access/expiration")
      .then(({ data }) => {
        setExpiraionDate(data.data);
      });
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <Box>
      <h2>Configurations (Only visible to Cystellar superuser)</h2>
      <hr />
      <p>
        <span style={dotStyle} title="Alive"></span>
        <b>Environment:</b> {process.env.REACT_APP_ENVIRONMENT}
      </p>

      <p>
        <span style={dotStyle} title="Alive"></span>
        <b>Backend URL:</b> {`${process.env.REACT_APP_BASE_URL}`}
      </p>
      <p>
        <span style={dotStyle} title="Alive"></span>
        <b>Auth URL:</b> {`${process.env.REACT_APP_AUTH_URL}`}
      </p>

      <p>
        <span style={dotStyle} title="Alive"></span>
        <b>Token expiration (UTC):</b> {`${expiraionDate}`}
      </p>

      <p>
        <span style={dotStyle} title="Alive"></span>
        <b>REACT_APP_HAZARD_BASE_API_URL:</b> (when APP connects to HazardAPI directly){" "}
        {`${REACT_APP_HAZARD_BASE_API_URL}`}
      </p>

      <p>
        <span style={dotStyle} title="Alive"></span>
        <b>USER:</b> email={user.email} , role={user.role}, name={user.name}
      </p>
      <p>
        <span style={dotStyle} title="Alive"></span>
        <b>FEATURES:</b> (in alphabetic order)
      </p>
      <ul>
        {user.features.sort().map((feature, index) => (
          <li key={index}>{feature} </li>
        ))}
      </ul>

      <hr />
      <div>
        <h2>Doppler Images</h2>
        <ul>
          {dopplerData &&
            dopplerData
              .reverse((a, b) => b - a)
              .map((data, index) => <li key={index}>{new Date(data.date).toISOString().slice(0, 10)}</li>)}
        </ul>
      </div>
    </Box>
  );
};
